// Scroll events if any. Usually this will be scripts for GSAP scrolltrigger animations.

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import _Flip from "gsap/Flip";

gsap.registerPlugin(ScrollTrigger);

const header = document.querySelector("#site-header");
const menuIcons = document.querySelector(".header-right");
const logo = document.querySelector(".logo");
const hero = document.querySelector(".hero .background-container");
const registerButton = document.querySelector(".register-button");
const headerInfo = document.querySelector("#header-info");

let scrolledPastHeader = false;
let scrolledPastHeaderNew = false;


window.addEventListener("scroll", () => {

  let heroBottom = hero ? hero.scrollHeight : "";
  let headerPadding = parseInt(window.getComputedStyle(headerInfo).paddingTop);
  let registerButtonHeight = ((registerButton.scrollHeight) + headerPadding);
  let headerBottom = header.scrollHeight;

  if (hero) {
    if (scrolledPastHeader === false && window.scrollY > (heroBottom - registerButtonHeight)) {
      scrolledPastHeader = true;
    } else if (scrolledPastHeader === true && window.scrollY <= heroBottom - registerButtonHeight) {
      scrolledPastHeader = false;
    }
  } else {
    if (scrolledPastHeader === false && window.scrollY > headerBottom) {
      scrolledPastHeader = true;
    } else if (scrolledPastHeader === true && window.scrollY <= headerBottom) {
      scrolledPastHeader = false;
    }
  }

  if (scrolledPastHeaderNew !== scrolledPastHeader) {
    header.classList.toggle("scrolled");
    scrolledPastHeaderNew = scrolledPastHeader;
    logo.classList.remove("with-transition");
  }

  // Hide register button on mobile
  if (window.scrollY > (registerButton.scrollHeight + headerPadding) + 1) {
    registerButton.classList.add("mobile-hide");
  } else {
    registerButton.classList.remove("mobile-hide");
  }

});

// Pin black logo

const heroLogo = document.querySelector(".hero-logo-black");
const copyDiv = document.querySelector(".statement-copy-home");
let viewportHeight = window.innerHeight;

window.addEventListener("resize", () => {
  viewportHeight = window.innerHeight;

  // if (footer.getBoundingClientRect().top > viewportHeight) {
  //     footerBG.style.height = 0;
  // } else {
  //     footerBG.style.height = `${window.innerHeight - footer.getBoundingClientRect().top}px`;
  // }
})

if (heroLogo) {
  const heroLogoSVG = heroLogo.querySelector("svg");
  const svgDiv = document.querySelector(".svg-div");


  ScrollTrigger.matchMedia({
    // large
    "(min-width: 1280px)": function () {
      ScrollTrigger.create({
        trigger: heroLogo,
        start: "top top",
        // end: () => {
        //     let val = (logoHeight / 2) + ((logoHeight / 100) * 89.1);
        //     return `bottom+=${val} center`;
        // },
        endTrigger: ".logo-end-trigger",
        end: () => {
          let heroHeight = hero.offsetHeight;
          let logoHeight = svgDiv.offsetHeight;
          return `+=${((heroHeight / 2) + (logoHeight / 2)) + 200}`;
        },
        pin: true,
        invalidateOnRefresh: true,
      });
    },
    // medium
    "(min-width:720px) and (max-width: 1279px)": function () {
      ScrollTrigger.create({
        trigger: heroLogo,
        start: "top top",
        end: () => {
          let heroHeight = hero.offsetHeight;
          let logoHeight = svgDiv.offsetHeight;
          return `+=${((heroHeight / 2) + (logoHeight / 2)) + 148}`;
        },
        pin: true,
        invalidateOnRefresh: true,
      });
    },
    // small
    "(max-width: 719px)": function () {
      ScrollTrigger.create({
        trigger: heroLogo,
        start: "top top",
        end: () => {
          let heroHeight = hero.offsetHeight;
          let logoHeight = svgDiv.offsetHeight;
          return `+=${((heroHeight / 2) + (logoHeight / 2)) + 97}`;
        },
        pin: true,
        invalidateOnRefresh: true,
      });
    },
  })
}


// Fade in and up on scroll
gsap.utils.toArray(".anim-fade-in-and-up-on-scroll:not(.done):not(.front-page-hero:first-of-type)").forEach((section) => {

  var tl = gsap.timeline({paused: true})

  tl.fromTo(section, {opacity: 0, y: '50px'}, {opacity: 1, y: '0px', duration: 1.5, ease: "power2.out"});

  ScrollTrigger.create({

    animation: tl,
    trigger: section,
    start: 'top 80%',
    toggleClass: {targets: section, className: "done"}

  });

});


// Parallax Images
const containers = gsap.utils.toArray(".img-container");

containers.forEach((container) => {
  const parallaxImg = container.querySelector(".parallax");
  gsap.to(parallaxImg, {
    yPercent: -5,
    scrollTrigger: {
      trigger: container,
      end: "bottom top",
      scrub: 0.5,
      ease: "none",
      invalidateOnRefresh: true,
    }
  });
})


// show footer background when footer is on screen
const footer = document.querySelector("#site-footer");
const footerBackground = document.querySelector(".footer-background");

gsap.from(footerBackground, {
  scrollTrigger: {
    trigger: "#site-footer",
    start: 'top bottom',
    end: "bottom top",
    toggleClass: {
      targets: footerBackground,
      className: "visible",
    },
  }
});

const residenceSlider = document.querySelector(".switch-container")


if (residenceSlider) {
  gsap.to(residenceSlider, {
    scrollTrigger: {
      start: 'top bottom-=40',
      trigger: footer,
      toggleActions: "play none none reverse",
    },
    opacity: 0,
    duration: 0.3,
  });
}


// const tableRow = document.querySelector(".floor-plans-wrapper");
// const td = document.querySelector("td.floor-plans");
// const button = document.querySelector(".floor-plan-button");
// button.addEventListener("click", () => {
//   td.classList.toggle("open");
//   tableRow.classList.toggle("open");
// })

const moreInfoButtons = document.querySelectorAll(".floor-plan-button");
const floorPlanRows = document.querySelectorAll(".floor-plans-wrapper");
const tableRows = document.querySelectorAll(".availability-table-row");
const tds = document.querySelectorAll("td.floor-plans");

function resetTable() {
  floorPlanRows.forEach(row => {
    row.classList.remove("open");
  })
  tableRows.forEach(row => {
    row.classList.remove("open");
  })
  tds.forEach(td => {
    td.classList.remove("open");
  })
  moreInfoButtons.forEach(button => {
    button.textContent = "More Info";
  })
}

function toggleTableClasses(i) {
  floorPlanRows[i].classList.toggle("open");
  tds[i].classList.toggle("open");
  tableRows[i].classList.toggle("open");
}

if (moreInfoButtons.length) {
  moreInfoButtons.forEach((button, i) => {
    button.addEventListener("click", (e) => {
      if (!floorPlanRows[i].classList.contains("open")) {
        resetTable();
        toggleTableClasses(i);
        button.textContent = "Less Info";
      } else {
        toggleTableClasses(i);
        button.textContent = "More Info";
      }
    })
  })
}